<section class="navbar-links d-flex justify-content-center">
  <ul class="d-flex align-items-center parent m-0">

    <li class="text-center">
      <a [routerLink]="['/', lang]" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <p>Home</p>
      </a>
    </li>

    <li class="text-center" *ngFor="let item of mainCategoryList">
      <a href="" (click)="navigateToCategory(item)" [routerLink]="['/', this.lang,'categories',item.slug]"
        [class.active]="isActive(item.slug)">
        <p>{{ item.name?.[arabic ? 'ar' : 'en'] ? item.name?.[arabic ? 'ar' : 'en'] : item.name?.['en']}}</p>
      </a>
    </li>
  </ul>
</section>